import React, {Component} from 'react';

import epicorService from '../../store/services/epicor';
import Page from '../layout/Page';
import FormContainer from '../form-components/FormContainer';
import OrderTable from '../components/OrderTable';
import {Item} from 'semantic-ui-react';

class OrderHistory extends Component {
  state = {
    orders: [],
  };

  async componentDidMount() {
    try {
      this.setState({loading: true});
      const {result} = await epicorService.fetchOrders();
      this.setState({orders: result || []});
    } catch (error) {
      this.setState({error});
    } finally {
      this.setState({loading: false});
    }
  }

  render() {
    const {loading, orders} = this.state;

    return (
      <Page.Basic title="Order History">
        <FormContainer loading={loading}>
          {!!orders.length && <OrderTable orders={orders} />}
          {!!orders && orders.length === 0 && (
            <Item.Group>
              <Item>
                <Item.Content verticalAlign="middle">
                  <strong>No Results Found </strong>
                </Item.Content>
              </Item>
            </Item.Group>
          )}
        </FormContainer>
      </Page.Basic>
    );
  }
}

export default OrderHistory;
